<template>
    <div>
        <div class="my-3">
            <input class="form-control" type="text" id="search" placeholder="Search" v-model="searchValue" @keyup="startSearch()">
        </div>
        <div class="accordion accordion-flush" id="faqAccordian" ref="faqParent">
            <div class="accordion-section">
                <h2>How to Choose Your Tyres</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            How do I find out my tyre size?
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>If you check your current tyres, they will have the size on the sidewall of the tyres. The tyre size will look like this: “225/45R18 91W”. Be sure to check the front and back tyres as they may be different sizes.</p>
                            <br class="clear"/>
                            <p>You can check the tyre size in the car manual, but this might not always be accurate if the manufacturers standard wheels are no longer fitted. </p>
                            <br class="clear"/>
                            <p>You can also put your vehicle registration into our website, but checking your tyre sidewall is the most accurate way.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Is tyre labelling important?
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>The European regulations passed on the 1st November 2012 state that all tyres must be labelled with their performance on wet roads, fuel economy, rolling distance and noise.</p>
                            <br class="clear"/>
                            <p>These new labels are very easy to read, they have similar colour coding to the labels displayed on white goods i.e washing machines and fridges. Tyres are rated on a scale of A-G, A being the highest rating. This makes it better for consumers as you can now make an informed decision through performance ratings.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Do I need to stick with the brand currently fitted?
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>No, you don't need to stick with the same brand. It is always best to replace them with a similar specification of tyre or better. It’s also important to note that for the best performance, having the same make and model or tyres all-round is the best way to go.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        Why isn't my vehicle showing on the vehicle reg lookup?
                        </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                If you have changed your registration lately or have a newly registered vehicle, this can take time to show in the database. We use the DVLA vehicle type database so, if you’re concerned that your vehicle isn’t showing, it will be best to contact the DVLA at <a href="https://www.dft.gov.uk/dvla">https://www.dft.gov.uk/dvla</a>. You can still order tyres by entering your tyre size on the home page.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Ordering Your Tyres</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                            Is ordering from you easy?
                        </button>
                    </h2>
                    <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>All you need to do is enter your vehicle reg or your tyre size. Once you have picked your tyres, you will enter your postcode, select a fitter, select a fitting date and time. You will be then sent to a payment page to complete your order.</p>
                            <br class="clear"/>
                            <p>After payment, you will receive a confirmation email confirming your order.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSeven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                            Where is my confirmation email?
                        </button>
                    </h2>
                    <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Your confirmation email may have been filtered into your Spam folder. If you check and it's not there, email <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> and we will resend this for you.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEight">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                            What do I do if I order the wrong size?
                        </button>
                    </h2>
                    <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Don’t worry, if you order the wrong size or the wrong tyre, contact us on <a href="tel:{{ contactNumber }}">{{ contactNumber }}</a> and <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> as soon as possible and we will change the order for you. Please note that if there is a difference in price, this will be charged, if the amount is less, you will get a refund. There may also be a change in the fitting date or time due to delivery times.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingNine">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                            Is wheel alignment important?
                        </button>
                    </h2>
                    <div id="collapseNine" class="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Yes, having the correct wheel alignment improves the handling on the road and helps with the longevity of your tyres. If you purchase this through us and this isn't needed, simply contact us on <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> and we will refund this for you.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                            Is my fitting appointment set in stone?
                        </button>
                    </h2>
                    <div id="collapseTen" class="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Most times, yes, but sometimes delays with delivery and weather conditions can change this. If there are any issues or delays, we will do our best to notify you to try and rectify this.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEleven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                            What is included in the price?
                        </button>
                    </h2>
                    <div id="collapseEleven" class="accordion-collapse collapse" aria-labelledby="headingEleven" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                If you select fitting our price includes your tyres, fitting at a fitting centre on our network, wheel balancing and disposal of your old tyres.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Payment Information</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFourteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                            Do I get a VAT invoice?
                        </button>
                    </h2>
                    <div id="collapseFourteen" class="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Your confirmation email includes the breakdown of the VAT required for a VAT invoice.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFifteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                            Why do you need my contact details?
                        </button>
                    </h2>
                    <div id="collapseFifteen" class="accordion-collapse collapse" aria-labelledby="headingFifteen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>We use your email address to provide you with your confirmation email and we use your contact number to get in touch with you about any questions with your order. We also send the confirmation via text message.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Tyre Fitting Queries</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSeventeen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                            Who carries out the fitting and are they qualified?
                        </button>
                    </h2>
                    <div id="collapseSeventeen" class="accordion-collapse collapse" aria-labelledby="headingSeventeen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>All of our fitting partners are carefully selected and audited. Each technician is qualified to City &amp; Guild Standards.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEighteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                            Do you offer tyre rotation?
                        </button>
                    </h2>
                    <div id="collapseEighteen" class="accordion-collapse collapse" aria-labelledby="headingEighteen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Unfortunately, we do not offer this service, but you can speak to the selected garage in relation to this. The price won’t be included in the price paid to ourselves as this will be determined by the fitting centre.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingNineteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                            Do I need to take anything to my fitting?
                        </button>
                    </h2>
                    <div id="collapseNineteen" class="accordion-collapse collapse" aria-labelledby="headingNineteen" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>You just need your reference number or confirmation email and your locking wheel nut.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwenty">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
                            Do I need to let the garage know about my fitting?
                        </button>
                    </h2>
                    <div id="collapseTwenty" class="accordion-collapse collapse" aria-labelledby="headingTwenty" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>No, we send a confirmation email of the fitting to the fitting centre selected. You only need to contact the fitting centre if you have a large or unusual vehicle.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyOne" aria-expanded="false" aria-controls="collapseTwentyOne">
                            Can I change my appointment time?
                        </button>
                    </h2>
                    <div id="collapseTwentyOne" class="accordion-collapse collapse" aria-labelledby="headingTwentyOne" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Of course, if you’re wanting to change your appointment you can email <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> and we will have this arranged for you.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyTwo" aria-expanded="false" aria-controls="collapseTwentyTwo">
                            What if my car has centreless alloys?
                        </button>
                    </h2>
                    <div id="collapseTwentyTwo" class="accordion-collapse collapse" aria-labelledby="headingTwentyTwo" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Some vehicles such as Citroens and Peugeots have alloy wheels, which do not have removable centre caps. These are called Centreless alloys. If your car has centreless alloys, a universal adapter is needed in order to complete a tyre fitting. We would always recommend calling a garage prior to booking an order to check if they have the ability to complete the fitting. If there is not a local garage in your area which has this universal adapter, it is advised that you go to a Citroen or Peugeot dealer.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Product Information</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyFour" aria-expanded="false" aria-controls="collapseTwentyFour">
                            Do my tyres come with a guarantee?
                        </button>
                    </h2>
                    <div id="collapseTwentyFour" class="accordion-collapse collapse" aria-labelledby="headingTwentyFour" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                Yes, your tyres come with a 12 month workmanship and product guarantee. The guarantee covers any product faults or issues that arise from fitting. It does not cover accidental, malicious or damage caused by wear and tear.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyFive">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyFive" aria-expanded="false" aria-controls="collapseTwentyFive">
                            How do I make a claim?
                        </button>
                    </h2>
                    <div id="collapseTwentyFive" class="accordion-collapse collapse" aria-labelledby="headingTwentyFive" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                               Well make arrangements to collect the tyres from the garage where you had them fitted at a time convenient to you. The tyres are then sent back to the manufacturer for investigation. The investigation can take upto 10 weeks and replacement tyres are not provided during this time. Therefore please consider what arrangements you will make whilst it takes place.
                            </p>
                            <br class="clear"/>
                            <p>The results will be sent to you directly by the manufacturer. If a fault is found, a refund will be arranged through the garage who fit the tyres.</p>
                            <br class="clear"/>
                            <p>Refunds are based on the tread worn. For example, 50% worn tread would give a 50% refund on the cost of the tyres. If no fault is found the manufacturer will arrange for the tyres to be returned to you and no refund will be issued.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentySix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentySix" aria-expanded="false" aria-controls="collapseTwentySix">
                            Who do I contact if I'm unhappy?
                        </button>
                    </h2>
                    <div id="collapseTwentySix" class="accordion-collapse collapse" aria-labelledby="headingTwentySix" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>The BTMA tells us the experience within the industry over many years shows that tyre complaints are most commonly the result of poor care and maintenance or driver influence and tyre underperformance is rarely due to manufacturing defects. There are a number of reasons why tyres may wear down quicker than anticipated.</p>
                            <br class="clear"/>
                            <p>If you are unhappy with the result of the manufacturer examination please refer to guidance set out by the BTMA. If you arrange an independent tyre examination and this shows different results to the manufacturer report please send these directly to <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> for review.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyEight">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyEight" aria-expanded="false" aria-controls="collapseTwentyEight">
                            Are all of your tyres brand new?
                        </button>
                    </h2>
                    <div id="collapseTwentyEight" class="accordion-collapse collapse" aria-labelledby="headingTwentyEight" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>
                                All of our tyres are new. Tyres are classed as "brand new" if correctly stored for up to 3 years and "new" for up to 5 years. This is following BRV (German National Association for the tyre and vulcaniser trade). Our tyres are generally less than 18 months old.
                            </p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Tyre Recommendations</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwentyNine">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyNine" aria-expanded="false" aria-controls="collapseTwentyNine">
                            How do I know if my tyres need replacing?
                        </button>
                    </h2>
                    <div id="collapseTwentyNine" class="accordion-collapse collapse" aria-labelledby="headingTwentyNine" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Apart from them having illegal tread depth, more reasons to replace your tyres include:</p>
                            <ul>
                                <li>Bald patches on the tread</li>
                                <li>Bulges in the sidewall</li>
                                <li>The internal construction can be seen</li>
                                <li>One of the tyres differs in size to the one on the opposite axel</li>
                                <li>Cracks in the sidewall, splits or perished rubber</li>
                            </ul>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirty">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirty" aria-expanded="false" aria-controls="collapseThirty">
                            Does the speed rating reading matter?
                        </button>
                    </h2>
                    <div id="collapseThirty" class="accordion-collapse collapse" aria-labelledby="headingThirty" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, you can check this in your handbook. It's so important that you have tyres with the same speed rating or one slightly higher than the ones your vehicle was originally fitted with. This will ensure your vehicle is safe to drive and your insurance is valid.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyOne" aria-expanded="false" aria-controls="collapseThirtyOne">
                            What is the correct tyre pressure for my vehicle?
                        </button>
                    </h2>
                    <div id="collapseThirtyOne" class="accordion-collapse collapse" aria-labelledby="headingThirtyOne" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>You can find the correct pressure for your vehicle on the inside of the petrol cap or in your handbook. Tyre pressure will change as the load and weight of your car changes, so you should try and check your pressure on a weekly basis to ensure they are safe at all times.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyTwo" aria-expanded="false" aria-controls="collapseThirtyTwo">
                            Do I need Run-Flat tyres?
                        </button>
                    </h2>
                    <div id="collapseThirtyTwo" class="accordion-collapse collapse" aria-labelledby="headingThirtyTwo" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>If you check the tyres on your vehicle, this will state on the sidewall if they are run-flat tyres, You should not fit Run Flat tyres to a car that is not set up to use them, nor should you fit normal tyres to a car set up for Run Flat Tyres.</p>
                            <br class="clear"/>
                            <p>Run Flat tyres are specially designed with a reinforced sidewall that can hold the weight of a car when the pressure drops. This is helpful to maintain mobility if the tyre has a puncture.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyThree" aria-expanded="false" aria-controls="collapseThirtyThree">
                            Do I need to tell my insurer if I fit Winter Tyres?
                        </button>
                    </h2>
                    <div id="collapseThirtyThree" class="accordion-collapse collapse" aria-labelledby="headingThirtyThree" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, your premium shouldn’t be affected, but it is always best to notify your insurer of any changes on your vehicle.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyFour" aria-expanded="false" aria-controls="collapseThirtyFour">
                            Is a spare tyre important?
                        </button>
                    </h2>
                    <div id="collapseThirtyFour" class="accordion-collapse collapse" aria-labelledby="headingThirtyFour" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Most cars don’t come with a spare tyre, but we believe it is a good idea to have a spare tyre in good condition in case you suffer from a flat tyre, a blowout or severe damage to one of your tyres.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Returns and Refunds</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtySeven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtySeven" aria-expanded="false" aria-controls="collapseThirtySeven">
                            How does the cancellation process work?
                        </button>
                    </h2>
                    <div id="collapseThirtySeven" class="accordion-collapse collapse" aria-labelledby="headingThirtySeven" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>To cancel your order please email us at <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> and include your order reference number.</p>
                            <br class="clear"/>
                            <p>Garage fit: There is no cancellation charge for garage fitted tyres.</p>
                            <br class="clear"/>
                            <p>Home delivery: For home delivery orders, in the event that a customer requires for tyres to be collected the collection fee will be subtracted from any refunds later processed.</p>
                            <br class="clear"/>
                            <p>Mobile fit: If cancelled before the day of your appointment the full mobile fitting fee will be refunded. If the cancellation happens on or after the day of your fitting you will not be refunded the mobile fitting fee.</p>
                            <br class="clear"/>
                            <p>If part of our service has caused you to cancel, please let us know and we'll do our best to help. Once we have processed your cancellation request, we will arrange your refund and confirm this by email.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtySevena">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtySevena" aria-expanded="false" aria-controls="collapseThirtySevena">
                            What do I do if I'm unhappy with my order?
                        </button>
                    </h2>
                    <div id="collapseThirtySevena" class="accordion-collapse collapse" aria-labelledby="headingThirtySevena" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                        <p>If you are unhappy with your purchase, please contact us as soon as possible. Please note that if the tyre has been driven on, we are unable to replace this. If you have any further questions, please email us at <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a>.</p>
                        <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtySevenb">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtySevenb" aria-expanded="false" aria-controls="collapseThirtySevenb">
                            What is your refund policy?
                        </button>
                    </h2>
                    <div id="collapseThirtySevenb" class="accordion-collapse collapse" aria-labelledby="headingThirtySevenb" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                        <p>To organise a refund please email us at <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> with your reference number. All refunds will be made by crediting the card you paid with.</p>
                        <br class="clear"/>
                        <p>We will make all refunds within 14 days of receiving your notification that you wish to return the item(s), or of receiving the item(s) back.</p>
                        <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>Motoring Questions</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyEight">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyEight" aria-expanded="false" aria-controls="collapseThirtyEight">
                            What do I do if my steering wheel vibrates at high speed?
                        </button>
                    </h2>
                    <div id="collapseThirtyEight" class="accordion-collapse collapse" aria-labelledby="headingThirtyEight" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Go to your nearest garage for them to check over your vehicle. Tyre wear, wheel alignment and imbalance can cause the steering wheel to vibrate. It is important they aren't left unchecked by a garage, as it could cause long-term effects such as high fuel consumption, steering and braking problems.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThirtyNine">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyNine" aria-expanded="false" aria-controls="collapseThirtyNine">
                            What do I do if my car veers to one side?
                        </button>
                    </h2>
                    <div id="collapseThirtyNine" class="accordion-collapse collapse" aria-labelledby="headingThirtyNine" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>You may need to have your wheels realigned if it pulls to one side. Whilst low tread could be a factor, it is not likely that general wear or tear of tyres would cause this. In any case, it is always best to get your nearest garage to check and correct this for you.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFourty">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourty" aria-expanded="false" aria-controls="collapseFourty">
                            Can you help with puncture repair?
                        </button>
                    </h2>
                    <div id="collapseFourty" class="accordion-collapse collapse" aria-labelledby="headingFourty" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>No, we do not offer this service unfortunately, we can only help with a replacement.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFourtyOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourtyOne" aria-expanded="false" aria-controls="collapseFourtyOne">
                            Should I check my tyre after I hit a curb?
                        </button>
                    </h2>
                    <div id="collapseFourtyOne" class="accordion-collapse collapse" aria-labelledby="headingFourtyOne" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, it is always best to check any impact on your tyres to ensure there is no damage caused to your tyres or your vehicle.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section" v-if="payWithPaypal">
                <h2>PayPal</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFifty">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFifty" aria-expanded="false" aria-controls="collapseFifty">
                            What is PayPal Pay in 3?
                        </button>
                    </h2>
                    <div id="collapseFifty" class="accordion-collapse collapse" aria-labelledby="headingFifty" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Please see <a href="https://www.paypal.com/uk/webapps/mpp/paypal-payin3/faq" target="_blank">https://www.paypal.com/uk/webapps/mpp/paypal-payin3/faq</a> for details about PayPal Pay in 3.</p>      
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftyOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyOne" aria-expanded="false" aria-controls="collapseFiftyOne">
                            What is PayPal Credit?
                        </button>
                    </h2>
                    <div id="collapseFiftyOne" class="accordion-collapse collapse" aria-labelledby="headingFiftyOne" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>PayPal Credit is like a credit card, without the plastic. It's a credit limit that's attached to your PayPal account which you can use for your online purchases.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftyTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyTwo" aria-expanded="false" aria-controls="collapseFiftyTwo">
                            How do I apply?
                        </button>
                    </h2>
                    <div id="collapseFiftyTwo" class="accordion-collapse collapse" aria-labelledby="headingFiftyTwo" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Applying for PayPal Credit is easy. Simply select PayPal as an option on our checkout page, then choose PayPal Credit and complete a short application form. If approved, you'll have a credit limit linked to your PayPal account once you have accepted the Credit Agreement.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftyThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyThree" aria-expanded="false" aria-controls="collapseFiftyThree">
                            Do I need to reapply if I already have PayPal credit?
                        </button>
                    </h2>
                    <div id="collapseFiftyThree" class="accordion-collapse collapse" aria-labelledby="headingFiftyThree" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>No you don’t need to reapply. Just select the PayPal credit option in the payment section.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftyFour">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyFour" aria-expanded="false" aria-controls="collapseFiftyFour">
                            How long does it take to apply for/receive PayPal Credit?
                        </button>
                    </h2>
                    <div id="collapseFiftyFour" class="accordion-collapse collapse" aria-labelledby="headingFiftyFour" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>The application form takes minutes to complete. PayPal then run a credit check and if approved, you’ll have a credit limit linked to your PayPal account as soon as you accept your Credit Agreement.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftyFive">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyFive" aria-expanded="false" aria-controls="collapseFiftyFive">
                            How does the 0% for 4 months offer work?
                        </button>
                    </h2>
                    <div id="collapseFiftyFive" class="accordion-collapse collapse" aria-labelledby="headingFiftyFive" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>0% interest for 4 months is available on single transactions of &pound;{{ paypalCreditMinimumSpend }} or more. It applies automatically to any purchase made using PayPal Credit in excess of this value, except those to which another Promotional Purchase Offer (such as an instalment offer) applies. You can use this offer as many times as you like as long as you have an available credit limit.</p>
                            <br class="clear"/>
                            <p>Any remaining balance due after the 4-month promotional period or any transactions under &pound;{{ paypalCreditMinimumSpend }} will be charged at 19.9% p.a (variable). If you fail to make minimum repayments on time or in certain other circumstances, PayPal may remove your offer. Please see the Credit Agreement for more details.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftySix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftySix" aria-expanded="false" aria-controls="collapseFiftySix">
                            How much will my credit line be?
                        </button>
                    </h2>
                    <div id="collapseFiftySix" class="accordion-collapse collapse" aria-labelledby="headingFiftySix" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>To determine the size of your credit line PayPal use the information you provide in the application form along with internal PayPal data and an external credit check.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFiftySeven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftySeven" aria-expanded="false" aria-controls="collapseFiftySeven">
                            What happens if I want to return an item I purchased with PayPal credit?
                        </button>
                    </h2>
                    <div id="collapseFiftySeven" class="accordion-collapse collapse" aria-labelledby="headingFiftySeven" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>To organise a refund please e-mail us at <a href="mailto:{{ customerServicesEmail }}">{{ customerServicesEmail }}</a> or phone us on <a href="tel:{{ contactNumber }}">{{ contactNumber }}</a> with your reference number.  Subject to our normal terms and conditions about the product being unused and collection charges for home delivered tyres you will receive a full refund to your PayPal credit account.</p>
                            <br class="clear"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="accordion-section">
                <h2>TPMS</h2>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS1">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS1" aria-expanded="false" aria-controls="collapseTPMS1">
                            What is TPMS?
                        </button>
                    </h2>
                    <div id="collapseTPMS1" class="accordion-collapse collapse" aria-labelledby="headingTPMS1" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>TPMS stands for Tyre Pressure Monitoring System.</p>      
                            <p>TPMS is a system which will track your tyre’s air pressure. If your tyre pressure drops below a certain level, the system will alert the driver. TPMS helps improve fuel efficiency, road safety, and tyre longevity.</p>
                            <p>On or after the 1st January 2012, in the UK, all new cars and LCV’s - up to 3.5, tonnes must be fitted with a working TPMS By law. This was introduced off the back of the EU's Regulation 661/2009.</p>
                            <p>Despite the UK’s exit from the EU (Brexit), the UK’s government introduced this as part of UK domestic legislation. As such, all new vehicles from Jan 1st 2012 will be fitted with a tyre pressure monitoring system.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS2">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS2" aria-expanded="false" aria-controls="collapseTPMS2">
                            TPMS: Road Safety
                        </button>
                    </h2>
                    <div id="collapseTPMS2" class="accordion-collapse collapse" aria-labelledby="headingTPMS2" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>The road safety aspect of the tyre management system (TPMS) comes from the ability of the system to help reduce the use of underinflated tyres. Tyres with an inadequate air pressure suffer from longer braking distances and in very extreme circumstances you can suffer a tyre blowout.</p>
                            <p>Please remember that TPMS laws and regulations may differ depending on the country. Therefore, we suggest we check the rules and regulations in your own region to ensure you are compliant with your own country's laws.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS3">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS3" aria-expanded="false" aria-controls="collapseTPMS3">
                            What is TPMS
                        </button>
                    </h2>
                    <div id="collapseTPMS3" class="accordion-collapse collapse" aria-labelledby="headingTPMS3" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>A Tyre Pressure Monitoring System is an electronic system within your vehicle that measures the air pressure inside the tyres. The system alerts the driver when the air pressure drops below a certain level. There are 2 types of TPMS, indirect and direct.</p>
                            <b>Direct TPMS</b>
                            <p>Direct TPMS has sensors inside each tyre on the vehicle to measure the air pressure and temperature, this will then transmit data to the vehicle's onboard computer. The information should then be visible to the driver via their dashboard when driving.</p>
                            <b>Indirect TPMS</b>
                            <p>Indirect TPMS has wheel speed sensors that are installed onto the vehicle to determine if one or more tyres are underinflated, this is based on the difference in rotational speed between the tyres. The driver will be notified by a message shown on the vehicle’s dashboard.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS4">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS4" aria-expanded="false" aria-controls="collapseTPMS4">
                            Are TPMS sensors universal?
                        </button>
                    </h2>
                    <div id="collapseTPMS4" class="accordion-collapse collapse" aria-labelledby="headingTPMS4" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>No, TPMS sensors are not universal. TPMS sensors vary in size, shape, and frequency. This is not a one size fits all option.</p>
                            <p>Vehicle manufacturers use different types of sensors. It is vital you use the correct TPMS sensor for your vehicle.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS5">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS5" aria-expanded="false" aria-controls="collapseTPMS5">
                            Can I turn off TPMS?
                        </button>
                    </h2>
                    <div id="collapseTPMS5" class="accordion-collapse collapse" aria-labelledby="headingTPMS5" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>We do not recommend you turn this feature off on your vehicle.</p>
                            <p>TPMS is a very important safety feature, this can help reduce the number of accidents caused by underinflated tyres.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS6">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS6" aria-expanded="false" aria-controls="collapseTPMS6">
                            Do you need special valve caps for TPMS?
                        </button>
                    </h2>
                    <div id="collapseTPMS6" class="accordion-collapse collapse" aria-labelledby="headingTPMS6" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, TPMS sensors require special valve caps and valve stems that are designed to work with the sensors.</p>
                            <p>Valve stems and caps are typically made of rubber or metal, they come in a specific shape and size to fit the sensors.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS7">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS7" aria-expanded="false" aria-controls="collapseTPMS7">
                            How are TPMS sensors powered?
                        </button>
                    </h2>
                    <div id="collapseTPMS7" class="accordion-collapse collapse" aria-labelledby="headingTPMS7" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Direct TPMS sensors have a small battery built in which power the sensors. Depending on the manufacturer and usage the battery is designed to last for several years.</p>
                            <p>Indirect TPMS sensors use existing wheel speed sensors to determine tyre pressure so do not require a battery.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS8">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS8" aria-expanded="false" aria-controls="collapseTPMS8">
                            Replacing or Rotating TPMS Sensors
                        </button>
                    </h2>
                    <div id="collapseTPMS8" class="accordion-collapse collapse" aria-labelledby="headingTPMS8" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>TPMS sensors are able to continuously monitor the pressure in each tyre and will alert a driver when a tyre's pressure falls below the recommended level. But what do you need to know about replacing them? Below is a list of our common queries.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS9">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS9" aria-expanded="false" aria-controls="collapseTPMS9">
                            Can you rotate tyres with TPMS sensors?
                        </button>
                    </h2>
                    <div id="collapseTPMS9" class="accordion-collapse collapse" aria-labelledby="headingTPMS9" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, rotation of tyres is allowed. After your tyres have been rotated, the system may need resetting to ensure an accurate reading.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS10">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS10" aria-expanded="false" aria-controls="collapseTPMS10">
                            Can I replace just 1 TPMS sensor?
                        </button>
                    </h2>
                    <div id="collapseTPMS10" class="accordion-collapse collapse" aria-labelledby="headingTPMS10" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, you can replace just one TPMS sensor, however we would not recommend this. TPMS sensors have a similar lifespan, so we would recommend you change all at the same time.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS11">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS11" aria-expanded="false" aria-controls="collapseTPMS11">
                            Can you swap TPMS sensors?
                        </button>
                    </h2>
                    <div id="collapseTPMS11" class="accordion-collapse collapse" aria-labelledby="headingTPMS11" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Yes, you are able to swap TPMS sensors. If you choose to swap your sensors, the system may need reprogramming to ensure an accurate reading. A local fitter would be able to assist with this. Extra charges may be applied.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS12">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS12" aria-expanded="false" aria-controls="collapseTPMS12">
                            Do you need to replace TPMS with a new tyre?
                        </button>
                    </h2>
                    <div id="collapseTPMS12" class="accordion-collapse collapse" aria-labelledby="headingTPMS12" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>When you change your tyre, you do not need to replace your TPMS every time. Common causes for replacement TPMS is due to damage or wear and tear (corrosion).</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS13">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS13" aria-expanded="false" aria-controls="collapseTPMS13">
                            When to replace a TPMS system?
                        </button>
                    </h2>
                    <div id="collapseTPMS13" class="accordion-collapse collapse" aria-labelledby="headingTPMS13" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>We would only recommend a new TPMS if it is not functioning properly or damaged. The typical lifespan is between 5-7 years.</p>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTPMS14">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTPMS14" aria-expanded="false" aria-controls="collapseTPMS14">
                            How much to fix or replace a TPMS sensor?
                        </button>
                    </h2>
                    <div id="collapseTPMS14" class="accordion-collapse collapse" aria-labelledby="headingTPMS14" data-bs-parent="#faqAccordian">
                        <div class="accordion-body">
                            <p>Fixing or replacing a TPMS sensor varies depending on the make and model of the vehicle.</p>
                            <p>On average, the cost can range from around £100 per sensor. For further information, please speak with your chosen fitter for further cost information.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'customerServicesEmail',
            'webName',
            'websiteUrl',
            'payment',
            'payWithPaypal',
            'paypalCreditMinimumSpend',
            'contactNumber',
            'weekdayOpeningTimes'
        ],
        data() {
            return {
                searchValue: '',
                typingTimer: ''
            }
        },
        methods: {
            startSearch() {
                let vm = this;
                let wrapper = document.getElementById('faqAccordian');
                this.search();

                clearTimeout();
                this.typingTimer = setTimeout(function() {vm.highlightSearchText()}, 700);

            },
            search() {
                let vm = this;
                var panels = document.getElementById('faqAccordian').getElementsByClassName('accordion-item');
                var headings = document.getElementById('faqAccordian').querySelectorAll('.accordion-section > h2');
                
                //Hide all headings as standard, then show matched heading in next loop.
                _.forEach(headings, function(heading, key) {
                    heading.style.display = 'none';
                });

                //Builds up faqText to hold all of the text from titles and paragraphs, to compare the search value against.
                _.forEach(panels, function(panel, key) {
                    //This was particularly long winded, refactor? lodash equivalents maybe?
                    let panelSection = panel.parentElement;
                    let sectionHeading = panelSection.childNodes[0];

                    let searchableText = '';
                    let button_text = panel.getElementsByClassName('accordion-header')[0].getElementsByClassName('accordion-button')[0].textContent;
                    let paragraphs = panel.getElementsByClassName('accordion-collapse')[0].getElementsByClassName('accordion-body')[0].querySelectorAll('p');
                    
                    _.forEach(paragraphs, function(paragraph, key) {
                        searchableText = searchableText + paragraph.textContent;
                    });
                    
                    searchableText = searchableText + button_text;

                    //jQuery does the above in 1 line.
                    // faq_question = $(this_child_panel).find('h3').text() + $(this_child_panel).find('p').text();

                    //Checks to see if the searchValue exists inside a panel, if it doesn't it hides that panel
                    if (searchableText.toLowerCase().includes(vm.searchValue.toLowerCase())) {
                        sectionHeading.style.display = 'block';
                        panel.style.display = "block";
                    }
                    else {
                        panel.style.display = "none";
                        // sectionHeading.style.display = 'none';
                    }
                });
            },
            highlightSearchText() {
                let vm = this;

                var context = document.querySelector('#faqAccordian');
                var instance = new Mark(context);
                instance.unmark({
                    done: function() {
                        instance.mark(vm.searchValue);
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>